import { TokenService } from "../../services/TokenService";

const headers = TokenService.getHeaders();
const authorizationBearer = TokenService.getAuthorizationBearer();

export const NodeAPIService = {

    getAll: async function () {
        let response;            
        try {            
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/GetNodes', {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)    

            return { error: response };
        }
    },
    getNodeTypes: async function () {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/GetNodeTypes', {
                headers: headers
            });
            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    addNode: async function (node) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/', {                
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer, 
                },
                body: JSON.stringify(node)
            });

            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    getNode: async function (id) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/' + id, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    updateNode: async function (id, node) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/' + id, {
                method: "PUT",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(node)
            });

            return await response.json();
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    getNodesByEmail: async function () {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/GetNodesByEmail/', {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)

            return {error: response};
        }
    },
    getNodesByMappingType: async function (mappingTypeId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/GetNodesByMappingType/' + mappingTypeId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    getNodesForScenario: async function (scenarioTypeId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/GetNodesForScenario/' + scenarioTypeId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    getEntitiesByNodeId: async function (nodeId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/GetEntitiesByNodeId/' + nodeId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    updateNodeEntities: async function (nodeEntities) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/UpdateNodeEntities', {
                method: "PUT",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
                body: JSON.stringify(nodeEntities)
            });

            return await response;
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('There was an error', error);
                console.log(nodeEntities);
            }
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response;
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },
    getNodesByEmailAndMappingTypeId: async function (mappingTypeId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/Node/GetNodesByEmailAndMappingTypeId/' + mappingTypeId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
};